export default "__VITE_ASSET__BXYbxc2W__"